import React, { FunctionComponent } from 'react'
import Svg, { G, Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const AuroraControlledMedsSpotIllustration: FunctionComponent<Props> = ({ size = 96 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 64 64' fill='none'>
      <Path
        d='M32.225 0.239258C27.8073 0.239258 23.5212 0.996819 19.4855 2.49044C9.87754 6.05186 3.12272 13.9474 0.952482 24.1524C-0.481698 30.806 -0.298315 36.9601 1.51654 42.9574C3.83349 50.6164 9.52089 57.0753 17.1205 60.6772C20.8932 62.4693 25.2273 63.4925 30.0003 63.7176C30.6137 63.7454 31.2372 63.7606 31.8569 63.7606C35.6865 63.7606 39.5388 63.2357 43.3076 62.2012C43.5972 62.1291 43.8729 62.0545 44.1638 61.9685C47.5507 60.9769 50.5987 59.4087 53.2065 57.3131C56.0382 55.0505 58.369 52.1822 60.127 48.7927C60.4735 48.125 60.8049 47.4218 61.1704 46.5808C63.1812 41.9114 64.1525 36.6844 63.9805 31.4586C63.8996 29.148 63.5556 26.6919 62.9612 24.1524C61.9823 20.032 60.3862 16.1569 58.345 12.9395C57.786 12.0757 57.2725 11.3497 56.7641 10.6971C53.0952 5.9646 47.3787 2.64347 40.2382 1.098C37.6151 0.631554 34.9188 0.240522 32.2262 0.240522L32.225 0.239258Z'
        fill={spotIllustration.background.fill}
      />
      <G transform='translate(19.6352 15.8290)'>
        <Path
          d='M20.3523 33.6802H3.91862C2.79429 33.6802 1.88244 32.7684 1.88244 31.644L1.1097 5.30265L23.5026 6.65336L22.3872 31.687C22.3631 32.7936 21.4589 33.6789 20.3523 33.6789V33.6802Z'
          fill={spotIllustration.primary.fill}
        />
        <Path
          d='M8.05235 23.5109C6.91254 22.5612 5.21871 22.7154 4.26906 23.8552C3.31941 24.995 3.47356 26.6888 4.61337 27.6385L8.81869 31.1422C9.9585 32.0919 11.6523 31.9377 12.602 30.7979C13.5516 29.6581 13.3975 27.9643 12.2577 27.0146L8.05235 23.5109Z'
          fill='#ABCEFE'
        />
        <Path
          d='M12.6019 30.7967C11.6521 31.9362 9.95863 32.0905 8.81786 31.1407L6.81329 29.4839L10.252 25.3559L12.2566 27.0126C13.3961 27.9624 13.5504 29.6559 12.6006 30.7967H12.6019Z'
          fill={spotIllustration.secondary.fill}
        />
        <Path
          d='M15.6658 23.0325L14.4 28.3578C14.057 29.8011 14.9489 31.2493 16.3923 31.5924C17.8357 31.9354 19.2838 31.0435 19.6269 29.6001L20.8926 24.2748C21.2357 22.8314 20.3437 21.3833 18.9004 21.0402C17.457 20.6971 16.0088 21.5891 15.6658 23.0325Z'
          fill='#ABCEFE'
        />
        <Path
          d='M18.9029 21.0431C20.3459 21.3858 21.2388 22.8351 20.8948 24.2782L20.3029 26.8101L15.0758 25.5669L15.6677 23.035C16.0105 21.5919 17.4598 20.6991 18.9029 21.0431Z'
          fill={spotIllustration.secondary.fill}
        />
        <Path
          d='M23.7983 3.33332L0.934892 3.18409C0.563068 3.18156 0.254478 3.46865 0.229184 3.83921L0.00153607 7.25645C-0.0250228 7.66116 0.296214 8.00516 0.702186 8.00516H23.9286C24.3282 8.00516 24.6469 7.67254 24.6305 7.27416L24.4952 4.00615C24.48 3.6318 24.1727 3.33585 23.7983 3.33332Z'
          fill={spotIllustration.secondary.fill}
        />
        <Path
          d='M22.2019 0.697713L2.86706 0.000858682C2.26 -0.0206414 1.72756 0.36383 1.62006 0.903861L0.736025 5.3392H23.8752L23.3617 1.65763C23.2871 1.12519 22.7964 0.719213 22.2019 0.697713Z'
          fill={spotIllustration.secondary.fill}
        />
      </G>
    </Svg>
  )
}
